/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (salesTypeId, connectionSalesTypes) => ({
    type: actions.EDIT_CONNECTION_SALES_TYPES,
    payload: {
        id: salesTypeId,
        connectionSalesTypes,
    },
});